import React from 'react';
import '../styles/Hero.css';

const Hero = ({ scrollTo }) => {
  return (
    <section id="home" className="relative h-screen flex flex-col items-center justify-center text-center text-white px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&q=80&w=1920" 
          alt="Maredumilli Mist Forest" 
          className="w-full h-full object-cover animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-emerald-950/40"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl">
        <span className="uppercase tracking-[0.2em] md:tracking-[0.3em] text-emerald-400 font-bold text-xs md:text-sm mb-4 md:mb-6 block animate-fade-in">Welcome to Maredumilli Forest</span>
        <h1 className="text-4xl sm:text-6xl md:text-8xl font-bold mb-6 md:mb-8 leading-tight">
          Live Where the <br/> <span className="italic text-emerald-300">Wild</span> Things Are
        </h1>
        <p className="text-sm md:text-xl mb-8 md:mb-12 max-w-2xl mx-auto opacity-90 font-light italic leading-relaxed">
          Deep in the heart of Andhra's Eastern Ghats, Jaladhara offers a raw encounter with nature's purest form.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button onClick={() => scrollTo('accommodations')} className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white px-8 md:px-10 py-4 md:py-5 rounded-full font-bold transition shadow-xl text-sm md:text-base">
            VIEW OUR STAYS
          </button>
          <a href="https://wa.me/919440766328" className="w-full sm:w-auto border-2 border-white/30 hover:bg-white hover:text-emerald-950 px-8 md:px-10 py-4 md:py-5 rounded-full font-bold transition flex items-center justify-center gap-2 text-sm md:text-base">
            <i className="fab fa-whatsapp"></i> WHATSAPP US
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div 
        onClick={() => scrollTo('accommodations')}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 cursor-pointer z-20 animate-bounce flex flex-col items-center gap-2"
      >
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-medium">Scroll</span>
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-emerald-400 rounded-full animate-scroll"></div>
        </div>
      </div>

      {/* Bottom Glow Effect */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-emerald-500/20 to-transparent pointer-events-none blur-xl"></div>
    </section>
  );
};

export default Hero;
